const CLICK_ID_STORAGE_KEY = "rw_rdt_cid";

declare global {
  interface Window {
    rdt?: (...args: unknown[]) => void;
  }
}

/**
 * Reads `rdt_cid` off the landing URL (present when a visit came from a
 * Reddit ad click) and persists it so it's still available once the visitor
 * reaches signup/checkout, potentially several pages later.
 */
export const captureRedditClickId = (): void => {
  const clickId = new URLSearchParams(window.location.search).get("rdt_cid");

  if (clickId) {
    window.localStorage.setItem(CLICK_ID_STORAGE_KEY, clickId);
  }
};

export const getRedditClickId = (): string | undefined =>
  window.localStorage.getItem(CLICK_ID_STORAGE_KEY) || undefined;

/**
 * Shared with the matching server-side Conversions API call so Reddit can
 * dedupe the pixel and CAPI events instead of double-counting the funnel step.
 */
export const generateRedditEventId = (): string => window.crypto.randomUUID();

export const trackRedditEvent = (
  eventName: string,
  metadata?: Record<string, unknown>,
  eventId?: string
): void => {
  if (typeof window.rdt !== "function") {
    return;
  }

  window.rdt(
    "track",
    eventName,
    metadata,
    eventId ? { uuid: eventId } : undefined
  );
};
